import type { DropdownOption } from '@equip.health/ui';

import {
  CareTeamProviderType,
  CareTeamProviderTypeNames,
} from '~/lib/constants/patients.constants';
import type { ReassignmentReasonCategory } from '~/lib/types/reassignment';

export const INCLUDED_PROVIDER_TYPES = [
  CareTeamProviderTypeNames[CareTeamProviderType.THERAPIST],
  CareTeamProviderTypeNames[CareTeamProviderType.DIETITIAN],
  CareTeamProviderTypeNames[CareTeamProviderType.RECOVERY_COACH],
  CareTeamProviderTypeNames[CareTeamProviderType.CAREGIVER_COACH],
];

export const DATE_PREFERENCE_OPTIONS: DropdownOption[] = [
  { label: 'Next day', value: 'TOMORROW' },
  { label: "After patient's next appointment", value: 'AFTER_NEXT_APPOINTMENT' },
  { label: 'Last day of ongoing patient care', value: 'LAST_DAY_OF_CARE' },
];

export const INITIATOR_TABS: { label: string; value: ReassignmentReasonCategory }[] = [
  { label: 'Equip-initiated', value: 'EQUIP' },
  { label: 'Family-initiated', value: 'FAMILY' },
];
